import { jsx } from "react/jsx-runtime";
import { EventRepeat as EventRepeatIcon } from "@mui/icons-material";
import { validateTidalLicense } from "../../base/index.js";
function EventRepeat(props) {
  return /* @__PURE__ */ jsx(
    EventRepeatIcon,
    {
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "EventRepeat",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
EventRepeat.tidalIconMeta = {
  name: "EventRepeat",
  categories: "mail,contact,calendar"
};
validateTidalLicense();
export {
  EventRepeat
};
//# sourceMappingURL=EventRepeat.js.map
